import React, { useContext } from 'react'
// import UserImage from './UserImage'
import { useNavigate } from 'react-router-dom'

import userImage from './../images/UserImagelarge.png'
import TitleIcons from './TitleIcons'
import UserData from './UserData'
import { TokenContext } from './Contexts/TokenContext'
import Toastify from 'toastify-js'
import { showMessage } from './Functions'

export default function UserInformation() {
  let {setIsToken} = useContext(TokenContext)
  
  const logoutBtnClick = () =>{
      localStorage.setItem("token",false)
      setIsToken(false)
      showMessage("Logged out successfully","#4cbc6a")
   }
  const UsericonA = [
    {key : 1,name: "Profile" , icon:"fa-solid fa-id-badge fa-sm",classname:"w-[30px] h-[30px] leading-[30px] bg-[#A9DEF9] rounded-md",link:""},
    {key : 2,name: "Find friends" , icon:"fa-solid fa-users fa-sm",classname:"w-[30px] h-[30px] leading-[30px] bg-[#A9DEF9] rounded-md",link:""},
    {key : 3,name: "User analytics" , icon:"fa-solid fa-arrow-up-right-dots fa-sm",classname:"w-[30px] h-[30px] leading-[30px] bg-[#A9DEF9] rounded-md",link:""}
]
const UsericonB = [
  {key : 1,name: "Settings" , icon:"fa-solid fa-gear",classname:"w-[30px] h-[30px] leading-[30px] bg-[#A9DEF9] rounded-md",link:""},
  {key : 2,name: "Security data" , icon:"fa-solid fa-file-shield",classname:"w-[30px] h-[30px] leading-[30px] bg-[#A9DEF9] rounded-md",link:""},
  {key : 3,name: "Logout" , icon:"fa-solid fa-arrow-right-from-bracket",classname:"w-[30px] h-[30px] leading-[30px] bg-red-500 rounded-md",logoutBtnClick: logoutBtnClick}
]
  return (
    <div className='md:w-[21vw] lg:w-[18vw] 2xl:w-[20vw] bg-white hidden md:flex flex-col py-16 gap-12 items-center fixed h-[100vh] left-0 overflow-y-auto'>
      <UserData userImage ={userImage} classname="block text-center" classImg="max-w-[80px] inline" name="Mohanned El-Banna" />
      <TitleIcons title="Explore panel" classtitle="text-red-400 font-semibold  " Usericon={UsericonA} classlist="flex-col"/>
      <TitleIcons title="Settings" classtitle="text-red-400 font-semibold " Usericon={UsericonB} classlist="flex-col sm:pb-14 lg:pb-0"/>
      
    </div>
  )
}
